import CandidateProfileQualifications from './CandidateProfileQualifications.component';

export default CandidateProfileQualifications;